// extracted by mini-css-extract-plugin
export default {"select":"select__e1iSUH","dangerText":"dangerText__r5lcc1","divider":"divider__hG4nGP"};